import type { ReactNode } from 'react';

import { useTheme } from '@emotion/react';

import type { CurrencyPosition } from '@twistopayments/design-system/utils';

import * as styles from './currency-sign.styles';

type Props = {
  children: ReactNode;
  disabled: boolean;
  position: CurrencyPosition;
};

export const CurrencySign = ({ disabled, children, position }: Props) => {
  const theme = useTheme();

  return (
    <span css={[styles.text(theme, position), disabled && styles.disabled(theme)]}>{children}</span>
  );
};
